import { Component, Inject, OnDestroy } from '@angular/core';
import { BaseComponent } from '@ridango/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Env from '@ridango/core/env';

export interface TermsDialogMobile {
    termsUrl: string;
    withAgreeButton: boolean;
    termsAgreed: boolean;
}

@Component({
    selector: 'ridango-terms-dialog-mobile',
    templateUrl: './terms-dialog-mobile.component.html',
    styleUrls: ['./terms-dialog-mobile.component.scss']
})
export class TermsDialogMobileComponent extends BaseComponent implements OnDestroy {
    constructor(
        public dialogRef: MatDialogRef<TermsDialogMobileComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TermsDialogMobile,
        @Inject('ENV') public env: Env
    ) {
        super();
    }

    agreeTerms(agree: boolean) {
        // If agree is true, set termsAgreed to true; otherwise keep the existing state
        const result = agree ? true : this.data.termsAgreed;
        this.dialogRef.close(result);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
